var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',_vm._l((_vm.visibleHeaders),function(header,index){return _c('td',{key:index},[(
        header.value &&
        _vm.fields[header.value] &&
        !_vm.fields[header.value].isGlobalFilter
      )?_c(_vm.fields[header.value].component,_vm._g(_vm._b({key:header.value,tag:"component",attrs:{"field-name":_vm.fields[header.value].name || header.value,"field-names-map":_vm.fields[header.value].fieldNamesMap},on:{"search":(search) =>
          _vm.fields[header.value].offline
            ? _vm.handleOfflineSearch(search)
            : _vm.handleSearch(search)}},'component',_vm.fields[header.value].attributes,false),_vm.fields[header.value].listeners)):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }